import { getReadableProviderName } from 'root/src/client/v2/auth/helpers/providerHelpers';
import { useQueryParam } from 'use-query-params';
import { StringQueryParam } from 'root/src/client/v2/queryParams/helpers/params.helper';
import { providerSearchValidatorSchema } from 'root/src/client/web/auth/hooks/useSignInWithProvider';
export const useSignInWithProviderModal = (params) => {
    const [providerSearchParam] = useQueryParam('provider', StringQueryParam({
        validator: providerSearchValidatorSchema,
    }));
    const provider = params.provider || providerSearchParam;
    if (!provider) {
        throw new Error('Provider is required');
    }
    const providerLabel = getReadableProviderName(provider);
    const header = params.header || 'Sign in';
    const label = params.label || `Please sign in with ${providerLabel} to continue`;
    return {
        header, label,
    };
};
